import { StoreState } from '../store-interfaces';

export const selectMyLeadsSearchOptions = (state: StoreState) =>
  state.myLeads.searchOptions;

export const selectMyLeadsContacts = (state: StoreState) =>
  state.myLeads.contacts;

export const selectMyLeadsPagination = (state: StoreState) =>
  state.myLeads.pagination;
